import React from 'react'
import { CChartLine } from '@coreui/react-chartjs'
import { memo } from 'react'

import './Dashboard.scss'
import { GRAY_300, GRAY_500, WHITE } from '../../../scss/colorConsts'

const LineChart = ({ data }) => {
  const chartBgColor = GRAY_500
  return (
    <CChartLine
      type="line"
      data={{
        labels:
          data?.length > 0 && data?.reduce((a, b) => a + b, 0) > 0
            ? data?.map((item) => {
                if (item >= 0) {
                  return ''
                }
              })
            : ['', '', '', '', ''],
        datasets: [
          {
            label: '',
            borderWidth: 1,
            // unused?
            backgroundColor: 'rgba(220, 220, 220, 0.2)',
            borderColor: 'var(--text-glow-color)',
            pointBackgroundColor: GRAY_300,
            pointBorderColor: WHITE,
            data: data || [],
          },
        ],
      }}
      options={{
        maintainAspectRatio: false,
        elements: {
          point: {
            radius: 1,
          },
        },
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            grid: {
              color: chartBgColor,
            },
            display: true,
          },
          y: {
            grid: {
              color: chartBgColor,
            },
            ticks: {
              color: chartBgColor,
            },
            beginAtZero: true,
            display: true,
          },
        },
      }}
    />
  )
}

export default memo(LineChart)
